import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getSessionNoteSignedByCredentialsApi from '../../../api/services/Session/getSessionNoteSignedByCredentials.service';
import schedulingApis from '../../../api/services/scheduling.service';

const initialState = {
  value: {},
  error: false,
  loading: false,
  cancelAppointment: false,
  signedByCredentials: null as null | {
    id?: number;
    firstName?: string;
    lastName?: string;
    credentials?: string;
  },
};
interface GetAppointmentData {
  id: string;
  appointmentRecurrenceId: any;
}
export const getAppointment = createAsyncThunk(
  'getSessionData',
  async (payload: GetAppointmentData, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getScheduleEventById(payload);
      return {
        ...res.data.data,
      };
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);

export const getSessionNoteSignedByCredentialsCall = createAsyncThunk(
  'getSessionNoteSignedByCredentials',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSessionNoteSignedByCredentialsApi.getSessionNoteSignedByCredentials();
      return res?.data?.data || null;
    } catch (err) {
      return rejectWithValue('Error in Response');
    }
  }
);

const appointmentSlice = createSlice({
  name: 'appointment',
  initialState,
  reducers: {
    setAppointmentData: (state, action) => {
      state.value = { ...action.payload };
    },
    setCancelAppointment: (state, action) => {
      state.cancelAppointment = action.payload;
    },
    clearAppointmentData: state => {
      state.value = {};
      state.signedByCredentials = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAppointment.pending, state => {
        state.loading = true;
      })
      .addCase(getAppointment.fulfilled, (state: any, action) => {
        state.value = action.payload;
        state.loading = false;
      })
      .addCase(getAppointment.rejected, state => {
        state.error = true;
        state.loading = false;
      })
      .addCase(getSessionNoteSignedByCredentialsCall.fulfilled, (state: any, action) => {
        state.signedByCredentials = action.payload;
      })
      .addCase(getSessionNoteSignedByCredentialsCall.rejected, state => {
        state.signedByCredentials = null;
      });
  },
});
export const { setAppointmentData, setCancelAppointment, clearAppointmentData } =
  appointmentSlice.actions;
export default appointmentSlice.reducer;
